import styled from '@emotion/styled';
import * as colors from '@airwallex/colors';
import { breakpoints } from '@airwallex/global';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  height: 100vh;
  width: 100%;
`;

export const LeftContainer = styled.div<{ hasBanner: boolean; isOnePageLayout: boolean }>`
  overflow-y: auto;
  display: flex;
  justify-content: ${({ isOnePageLayout }) => (isOnePageLayout ? 'center' : 'end')};
  flex-basis: ${({ isOnePageLayout }) => (isOnePageLayout ? '100%' : '50%')};
  padding: ${({ hasBanner }) => (hasBanner ? '40px 24px' : '80px 24px 40px 24px')};
  background-color: ${colors.grays[5]};
  @media (min-width: ${breakpoints.breakpointTokens.l + 1}px) {
    padding: ${({ hasBanner }) => (hasBanner ? '40px 40px' : '80px 40px 40px 40px')};
  }
  @media (min-width: 1441px) {
    flex-basis: ${({ isOnePageLayout }) => (isOnePageLayout ? '100%' : '60%')};
    padding: ${({ hasBanner }) => (hasBanner ? '40px 80px' : '80px 80px 40px 80px')};
  }
  @media (min-width: ${breakpoints.breakpointTokens.xl + 1}px) {
    flex-basis: ${({ isOnePageLayout }) => (isOnePageLayout ? '100%' : '60%')};
    padding: ${({ hasBanner }) => (hasBanner ? '40px 160px' : '80px 160px 40px 160px')};
  }
`;

export const RightContainer = styled.div`
  overflow-y: auto;
  padding: 80px 24px 40px 24px;
  flex-basis: 50%;
  @media (min-width: ${breakpoints.breakpointTokens.l + 1}px) {
    padding: 80px 40px 40px 40px;
  }
  @media (min-width: 1441px) {
    flex-basis: 40%;
    padding: 80px 80px 40px 80px;
  }
  @media (min-width: ${breakpoints.breakpointTokens.xl + 1}px) {
    padding: 80px 160px 40px 160px;
  }
`;

export const BodyContainer = styled.div`
  width: 100%;
  max-width: 760px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 40px;
`;

export const InvoicePanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-width: 440px;
  max-width: 760px;
`;
export const PaymentPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 440px;
`;
